import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createContactMail } from "../actions/contactMailActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import BlueLayout from "../layouts/BlueLayout";
import { AppInput } from "../components/global/AppInput";
import { AppSelect } from "../components/global/AppSelect";
import { useForm } from "../hooks/useForm";

const verifyEmail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

const ContactScreen = () => {
  const dispatch = useDispatch();

  const contactMailCreate = useSelector((state) => state.contactMailCreate);
  const { loading, error, contactMail } = contactMailCreate;

  const [errorMessage, setErrorMessage] = useState(null);

  const { formData, resetForm, handleInput } = useForm({
    subject: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    city: "",
    province: "",
    message: "",
  });

  const submitHandler = (e) => {
    e.preventDefault();
    if (
      formData.subject !== "hide" &&
      formData.firstName?.length &&
      formData.lastName?.length &&
      String(formData.email).toLowerCase().match(verifyEmail) &&
      formData.city?.length &&
      formData.province?.length
    ) {
      dispatch(createContactMail(formData));
      resetForm();
    } else {
      if (formData.subject === "hide") {
        setErrorMessage("Please select a subject");
      } else if (!String(formData.email).toLowerCase().match(verifyEmail)) {
        setErrorMessage("Invalid email address");
      } else {
        setErrorMessage("*= required feilds");
      }

      setTimeout(() => {
        setErrorMessage(null);
      }, 8000);
    }
  };

  return (
    <BlueLayout>
      {loading && <Loader />}
      {errorMessage && <Message body={errorMessage} />}
      {error && <Message body={error} />}
      {contactMail && <Message body={contactMail.message} type="info" />}
      <div className="container grid lg:grid-cols-2 gap-16 mb-10 pt-5 md:pt-28">
        <section>
          <h1 className="mb-5 text-4xl">
            Get In Touch With{" "}
            <span className="text-canton-jadesheen">Our Team</span>
          </h1>
          <p className="mb-7">
            Do you have a question or comment about the platform, or want to
            learn more about how it works? We are always available to help! Send
            us a message and one of our team will get back to you shortly.
          </p>
          <img
            src={require("../assets/images/contact/map.png")}
            alt="map"
            className="w-full"
          />
        </section>
        <section>
          <form
            onSubmit={submitHandler}
            className="grid gap-5"
            autoComplete="off"
          >
            <AppSelect
              id="subject"
              name="subject"
              label="How can we help you?"
              isRequired
              items={[
                { value: "Becoming a Partner", text: "Becoming a Partner" },
                { value: "Register as a Teacher", text: "Register as a Teacher" },
                { value: "Help Using the Platform", text: "Help Using the Platform" },
                { value: "Technical Support", text: "Technical Support" },
                { value: "Billing Issues", text: "Billing Issues" },
                { value: "Provide Feedback", text: "Provide Feedback" },
                { value: "Other", text: "Other" },
              ]}
              value={formData.subject}
              onChange={handleInput}
            />
            <AppInput
              id="firstName"
              name="firstName"
              type="text"
              label="First name"
              isRequired
              value={formData.firstName}
              onChange={handleInput}
            />
            <AppInput
              id="lastName"
              name="lastName"
              type="text"
              label="Last name"
              isRequired
              value={formData.lastName}
              onChange={handleInput}
            />
            <AppInput
              id="email"
              name="email"
              type="email"
              label="Email address"
              isRequired
              value={formData.email}
              onChange={handleInput}
            />
            <AppInput
              id="phone"
              name="phone"
              type="tel"
              label="Phone"
              value={formData.phone}
              onChange={handleInput}
            />
            <AppInput
              id="city"
              name="city"
              type="text"
              label="City"
              isRequired
              value={formData.city}
              onChange={handleInput}
            />
            <AppInput
              id="province"
              name="province"
              type="text"
              label="Province"
              isRequired
              value={formData.province}
              onChange={handleInput}
            />
            <AppInput
              id="message"
              name="message"
              type="text"
              label="Write your message here"
              isRequired
              value={formData.message}
              onChange={handleInput}
            />
            <button
              type="submit"
              className="bg-canton-jadesheen py-3 px-9 font-semibold"
            >
              Submit
            </button>
          </form>
        </section>
      </div>
      {/* <div className="container">
        <div className="contact-content" style={{ paddingTop: "30px" }}>
          <div className="cta">
            <div className="text">
              <h1>Get in touch with The VR Voyage Classroom team</h1>
              <p>
                Do you have a question or comment about the platform, or want to
                learn more about how it works? We are always available to help!
                Send us a message and one of our team will get back to you
                shortly.
              </p>
            </div>
            <div className="visual">
              <img id="mail" alt="" src="/images/mail.png" />
              <img id="mail-shadow" alt="" src="/images/mail-shadow.png" />
            </div>
          </div>
          <form onSubmit={submitHandler}>
            <div className="select">
              <select onChange={handleInput} value={subject}>
                <option value="hide">How can we help you? *</option>
                <option value="hide" disabled>
                  -- please choose an option --
                </option>
                <option value={`Becoming a Partner`}>Becoming a Partner</option>
                <option value={`Register as a Teacher`}>
                  Register as a Teacher
                </option>
                <option value={`Help Using the Platform`}>
                  Help Using the Platform
                </option>
                <option value={`Technical Support`}>Technical Support</option>
                <option value={`Billing Issues`}>Billing Issues</option>
                <option value={`Provide Feedback`}>Provide Feedback</option>
                <option value={`Other`}>Other</option>
              </select>
            </div>
            <input
              type="text"
              placeholder="first name *"
              onChange={firstNameHandler}
              value={firstName}
              required
            />
            <input
              type="text"
              placeholder="last name *"
              onChange={lastNameHandler}
              value={lastName}
              required
            />
            <input
              type="text"
              placeholder="email address *"
              onChange={emailHandler}
              value={email}
              required
            />
            <input
              type="text"
              placeholder="phone number (optional)"
              onChange={phoneHandler}
              value={phone}
            />
            <input
              type="text"
              placeholder="city *"
              onChange={cityHandler}
              value={city}
              required
            />
            <input
              type="text"
              placeholder="province *"
              onChange={provinceHandler}
              value={province}
              required
            />
            <textarea
              id="contact-textarea"
              name="contact-textarea"
              rows="8"
              cols="50"
              placeholder="write your message here *"
              onChange={messageHandler}
              value={message}
              required
            ></textarea>
            <div>
              <button className="btn" onClick={submitHandler}>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div> */}
    </BlueLayout>
  );
};

export default ContactScreen;
